import {
    Component,
    Input,
    signal,
    Output,
    EventEmitter,
    effect
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { VisualizationOptionsType } from "@arch/_shared/types/options-visualization";
import { ScenarioEntity } from "@arch/domain/entity";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";

@Component({
    selector: "app-report-adjustments-analisysplus",
    imports: [CommonModule, FormsModule, SharedMaterialModule, SharedDsnModule],
    templateUrl: "./report-adjustments-analisysplus.component.html",
    styleUrl: "./report-adjustments-analisysplus.component.scss"
})
export class ReportAdjustmentsAnalisysplusComponent {
    @Input({ required: true }) budgets: ScenarioEntity[];
    @Input({ required: true }) projections: ScenarioEntity[];
    @Input({ required: true }) set options(value: VisualizationOptionsType) {
        this.optionsSignal.set(value);
    }
    get options() {
        return this.optionsSignal();
    }
    private optionsSignal = signal<VisualizationOptionsType>(null);
    @Output() handleChangeAnalysis = new EventEmitter<{
        projection: ScenarioEntity;
        budget: ScenarioEntity;
        goals: boolean;
    }>();
    @Output() handleResetAnalysis = new EventEmitter<void>();

    public analysis = {
        projection: {
            active: false,
            value: ""
        },
        budget: {
            active: false,
            value: ""
        },
        goals: {
            active: false,
            value: ""
        }
    };

    constructor() {
        effect(() => {
            this.analysis.budget.value = this.options?.budget || "";
            this.analysis.budget.active = this.options?.budget ? true : false;
            this.analysis.projection.value =
                this.options?.projection || "PROGRESSAO_LINEAR";
            this.analysis.projection.active = this.options?.projection
                ? true
                : false;
            this.analysis.goals.active = this.options?.goals || false;
        });
    }

    public onToggleProjection(): void {
        this.analysis.budget.active = false;
        this.analysis.budget.value = "";
        this.analysis.projection.active = !this.analysis.projection.active;
        if (this.analysis.projection.active) {
            this.analysis.projection.value = "PROGRESSAO_LINEAR";
        }
    }

    public onToggleBudget(): void {
        this.analysis.projection.active = false;
        this.analysis.projection.value = "";
        this.analysis.budget.active = !this.analysis.budget.active;
        if (!this.analysis.budget.active) {
            this.analysis.budget.value = "";
        }
    }

    public onActiveGoals(): void {
        this.analysis.goals.active = !this.analysis.goals.active;
    }

    public onSelectBudget(event: any): void {
        this.analysis.budget.value = event;
    }

    public onSelectProjection(event: any): void {
        this.analysis.projection.value = event;
    }

    public onToggleGoals(): void {
        this.analysis.goals.active = !this.analysis.goals.active;
    }

    public onApply(): void {
        const budget = this.budgets.find(
            (budget) => budget.props._id === this.analysis.budget.value
        );
        const projection = this.projections.find(
            (projection) =>
                projection.props._id === this.analysis.projection.value
        );
        this.handleChangeAnalysis.emit({
            projection: this.analysis.projection.active ? projection : null,
            budget: this.analysis.budget.active ? budget : null,
            goals: this.analysis.goals.active
        });
    }

    public onReset(): void {
        this.handleResetAnalysis.emit();
    }
}
